export const text = {
    pageTitle: "STT Real Time",
    errorMsg: "مشکلی پیش آمده، لطفا دوباره تلاش کنید.",
    textPlaceholder: "Your speech will be shown here!",
    recordingMsg: "Recording...",
    stoppedMsg: "Press to start!",
    noSupport: "Your browser doesn't support Speech Recognition"
}


export const languages = [
    {country: "Iran", language: "fa-IR"},
    {country: "United States", language: "en-US"},
    {country: "South Africa", language: "af-ZA"},
    {country: "Algeria", language: "ar-DZ"},
    {country: "Bahrain", language: "ar-BH"},
    {country: "Egypt", language: "ar-EG"},
    {country: "Israel", language: "ar-IL"},
    {country: "Iraq", language: "ar-IQ"},
    {country: "Jordan", language: "ar-JO"},
    {country: "Kuwait", language: "ar-KW"},
    {country: "Lebanon", language: "ar-LB"},
    {country: "Morocco", language: "ar-MA"},
    {country: "Oman", language: "ar-OM"},
    {country: "Palestinian Territory", language: "ar-PS"},
    {country: "Qatar", language: "ar-QA"},
    {country: "Saudi Arabia", language: "ar-SA"},
    {country: "Tunisia", language: "ar-TN"},
    {country: "UAE", language: "ar-AE"},
    {country: "Spain", language: "eu-ES"},
    {country: "Bulgaria", language: "bg-BG"},
    {country: "Spain", language: "ca-ES"},
    {country: "China (Simp.)", language: "cmn-Hans-CN"},
    {country: "Hong Kong SAR (Trad.)", language: "cmn-Hans-HK"},
    {country: "Taiwan (Trad.)", language: "cmn-Hant-TW"},
    {country: "Hong Kong", language: "yue-Hant-HK"},
    {country: "Croatia", language: "hr_HR"},
    {country: "Czech Republic", language: "cs-CZ"},
    {country: "Denmark", language: "da-DK"},
    {country: "Australia", language: "en-AU"},
    {country: "Canada", language: "en-CA"},
    {country: "India", language: "en-IN"},
    {country: "Ireland", language: "en-IE"},
    {country: "New Zealand", language: "en-NZ"},
    {country: "Philippines", language: "en-PH"},
    {country: "South Africa", language: "en-ZA"},
    {country: "United Kingdom", language: "en-GB"},
    {country: "France", language: "fr-FR"},
    {country: "Philippines", language: "fil-PH"},
    {country: "Spain", language: "gl-ES"},
    {country: "Germany", language: "de-DE"},
    {country: "Greece", language: "el-GR"},
    {country: "Finland", language: "fi-FI"},
    {country: "Israel", language: "he-IL"},
    {country: "India", language: "hi-IN"},
    {country: "Hungary", language: "hu-HU"},
    {country: "Indonesia", language: "id-ID"},
    {country: "Iceland", language: "is-IS"},
    {country: "Italy", language: "it-IT"},
    {country: "Switzerland", language: "it-CH"},
    {country: "Japan", language: "ja-JP"},
    {country: "Korea", language: "ko-KR"},
    {country: "Lithuania", language: "lt-LT"},
    {country: "Malaysia", language: "ms-MY"},
    {country: "Netherlands", language: "nl-NL"},
    {country: "Norway", language: "nb-NO"},
    {country: "Poland", language: "pl-PL"},
    {country: "Brazil", language: "pt-BR"},
    {country: "Portugal", language: "pt-PT"},
    {country: "Romania", language: "ro-RO"},
    {country: "Russia", language: "ru-RU"},
    {country: "Serbia", language: "sr-RS"},
    {country: "Slovakia", language: "sk-SK"},
    {country: "Slovenia", language: "sl-SI"},
    {country: "Argentina", language: "es-AR"},
    {country: "Bolivia", language: "es-BO"},
    {country: "Chile", language: "es-CL"},
    {country: "Colombia", language: "es-CO"},
    {country: "Costa Rica", language: "es-CR"},
    {country: "Dominican Republic", language: "es-DO"},
    {country: "Ecuador", language: "es-EC"},
    {country: "El Salvador", language: "es-SV"},
    {country: "Guatemala", language: "es-GT"},
    {country: "Honduras", language: "es-HN"},
    {country: "México", language: "es-MX"},
    {country: "Nicaragua", language: "es-NI"},
    {country: "Panamá", language: "es-PA"},
    {country: "Paraguay", language: "es-PY"},
    {country: "Perú", language: "es-PE"},
    {country: "Puerto Rico", language: "es-PR"},
    {country: "Spain", language: "es-ES"},
    {country: "Uruguay", language: "es-UY"},
    {country: "United States", language: "es-US"},
    {country: "Venezuela", language: "es-VE"},
    {country: "Sweden", language: "sv-SE"},
    {country: "Thailand", language: "th-TH"},
    {country: "Turkey", language: "tr-TR"},
    {country: "Ukraine", language: "uk-UA"},
    {country: "Viet Nam", language: "vi-VN"},
    {country: "South Africa", language: "zu-ZA"},
]